/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 3.16.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddServiceproviderTeamMember201Response,
  AddServiceproviderTeamMemberRequest,
  CreateServiceprovider201Response,
  CreateServiceproviderRequest,
  GetClientTeam200ResponseInner,
  GetServiceprovider200Response,
  RemoveClientTeamMemberRequest,
  SetDatabaseChange200Response,
  SetDatabaseChange401Response,
  SetDatabaseChange500Response,
  SetQuickcheckSettingsRequest,
  UpdateServiceproviderRequest,
  UpdateUser400Response,
} from '../models/index';
import {
    AddServiceproviderTeamMember201ResponseFromJSON,
    AddServiceproviderTeamMember201ResponseToJSON,
    AddServiceproviderTeamMemberRequestFromJSON,
    AddServiceproviderTeamMemberRequestToJSON,
    CreateServiceprovider201ResponseFromJSON,
    CreateServiceprovider201ResponseToJSON,
    CreateServiceproviderRequestFromJSON,
    CreateServiceproviderRequestToJSON,
    GetClientTeam200ResponseInnerFromJSON,
    GetClientTeam200ResponseInnerToJSON,
    GetServiceprovider200ResponseFromJSON,
    GetServiceprovider200ResponseToJSON,
    RemoveClientTeamMemberRequestFromJSON,
    RemoveClientTeamMemberRequestToJSON,
    SetDatabaseChange200ResponseFromJSON,
    SetDatabaseChange200ResponseToJSON,
    SetDatabaseChange401ResponseFromJSON,
    SetDatabaseChange401ResponseToJSON,
    SetDatabaseChange500ResponseFromJSON,
    SetDatabaseChange500ResponseToJSON,
    SetQuickcheckSettingsRequestFromJSON,
    SetQuickcheckSettingsRequestToJSON,
    UpdateServiceproviderRequestFromJSON,
    UpdateServiceproviderRequestToJSON,
    UpdateUser400ResponseFromJSON,
    UpdateUser400ResponseToJSON,
} from '../models/index';

export interface AddServiceproviderTeamMemberOperationRequest {
    serviceproviderUUID: string;
    addServiceproviderTeamMemberRequest: AddServiceproviderTeamMemberRequest;
}

export interface CreateServiceproviderOperationRequest {
    createServiceproviderRequest: CreateServiceproviderRequest;
}

export interface DeleteServiceproviderRequest {
    serviceproviderUUID: string;
}

export interface GetServiceProviderTeamRequest {
    serviceproviderUUID: string;
}

export interface GetServiceproviderRequest {
    serviceproviderUUID: string;
}

export interface RemoveServiceproviderTeamMemberRequest {
    serviceproviderUUID: string;
    removeClientTeamMemberRequest: RemoveClientTeamMemberRequest;
}

export interface SetQuickcheckSettingsOperationRequest {
    serviceproviderUUID: string;
    setQuickcheckSettingsRequest: SetQuickcheckSettingsRequest;
}

export interface UpdateServiceproviderOperationRequest {
    serviceproviderUUID: string;
    updateServiceproviderRequest: UpdateServiceproviderRequest;
}

export interface UploadLogoRequest {
    serviceproviderUUID: string;
}

/**
 * 
 */
export class ServiceproviderApi extends runtime.BaseAPI {

    /**
     * Add member to serviceprovider team
     */
    async addServiceproviderTeamMemberRaw(requestParameters: AddServiceproviderTeamMemberOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddServiceproviderTeamMember201Response>> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling addServiceproviderTeamMember().'
            );
        }

        if (requestParameters['addServiceproviderTeamMemberRequest'] == null) {
            throw new runtime.RequiredError(
                'addServiceproviderTeamMemberRequest',
                'Required parameter "addServiceproviderTeamMemberRequest" was null or undefined when calling addServiceproviderTeamMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceprovider/{serviceproviderUUID}/collaboration/team`;
        urlPath = urlPath.replace(`{${"serviceproviderUUID"}}`, encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddServiceproviderTeamMemberRequestToJSON(requestParameters['addServiceproviderTeamMemberRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddServiceproviderTeamMember201ResponseFromJSON(jsonValue));
    }

    /**
     * Add member to serviceprovider team
     */
    async addServiceproviderTeamMember(serviceproviderUUID: string, addServiceproviderTeamMemberRequest: AddServiceproviderTeamMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddServiceproviderTeamMember201Response> {
        const response = await this.addServiceproviderTeamMemberRaw({ serviceproviderUUID: serviceproviderUUID, addServiceproviderTeamMemberRequest: addServiceproviderTeamMemberRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Create a new serviceprovider
     */
    async createServiceproviderRaw(requestParameters: CreateServiceproviderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateServiceprovider201Response>> {
        if (requestParameters['createServiceproviderRequest'] == null) {
            throw new runtime.RequiredError(
                'createServiceproviderRequest',
                'Required parameter "createServiceproviderRequest" was null or undefined when calling createServiceprovider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceprovider/`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateServiceproviderRequestToJSON(requestParameters['createServiceproviderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateServiceprovider201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new serviceprovider
     */
    async createServiceprovider(createServiceproviderRequest: CreateServiceproviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateServiceprovider201Response> {
        const response = await this.createServiceproviderRaw({ createServiceproviderRequest: createServiceproviderRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Delete serviceprovider
     */
    async deleteServiceproviderRaw(requestParameters: DeleteServiceproviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetDatabaseChange200Response>> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling deleteServiceprovider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceprovider/{serviceproviderUUID}`;
        urlPath = urlPath.replace(`{${"serviceproviderUUID"}}`, encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetDatabaseChange200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete serviceprovider
     */
    async deleteServiceprovider(serviceproviderUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetDatabaseChange200Response> {
        const response = await this.deleteServiceproviderRaw({ serviceproviderUUID: serviceproviderUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Get serviceprovider details
     */
    async getServiceProviderTeamRaw(requestParameters: GetServiceProviderTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetClientTeam200ResponseInner>>> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling getServiceProviderTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceprovider/{serviceproviderUUID}/collaboration/team`;
        urlPath = urlPath.replace(`{${"serviceproviderUUID"}}`, encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetClientTeam200ResponseInnerFromJSON));
    }

    /**
     * Get serviceprovider details
     */
    async getServiceProviderTeam(serviceproviderUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetClientTeam200ResponseInner>> {
        const response = await this.getServiceProviderTeamRaw({ serviceproviderUUID: serviceproviderUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Get serviceprovider details
     */
    async getServiceproviderRaw(requestParameters: GetServiceproviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetServiceprovider200Response>> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling getServiceprovider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceprovider/{serviceproviderUUID}`;
        urlPath = urlPath.replace(`{${"serviceproviderUUID"}}`, encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetServiceprovider200ResponseFromJSON(jsonValue));
    }

    /**
     * Get serviceprovider details
     */
    async getServiceprovider(serviceproviderUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetServiceprovider200Response> {
        const response = await this.getServiceproviderRaw({ serviceproviderUUID: serviceproviderUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Remover member from team
     */
    async removeServiceproviderTeamMemberRaw(requestParameters: RemoveServiceproviderTeamMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetDatabaseChange200Response>> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling removeServiceproviderTeamMember().'
            );
        }

        if (requestParameters['removeClientTeamMemberRequest'] == null) {
            throw new runtime.RequiredError(
                'removeClientTeamMemberRequest',
                'Required parameter "removeClientTeamMemberRequest" was null or undefined when calling removeServiceproviderTeamMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceprovider/{serviceproviderUUID}/collaboration/team`;
        urlPath = urlPath.replace(`{${"serviceproviderUUID"}}`, encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveClientTeamMemberRequestToJSON(requestParameters['removeClientTeamMemberRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetDatabaseChange200ResponseFromJSON(jsonValue));
    }

    /**
     * Remover member from team
     */
    async removeServiceproviderTeamMember(serviceproviderUUID: string, removeClientTeamMemberRequest: RemoveClientTeamMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetDatabaseChange200Response> {
        const response = await this.removeServiceproviderTeamMemberRaw({ serviceproviderUUID: serviceproviderUUID, removeClientTeamMemberRequest: removeClientTeamMemberRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Set quickcheck settings
     */
    async setQuickcheckSettingsRaw(requestParameters: SetQuickcheckSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetDatabaseChange200Response>> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling setQuickcheckSettings().'
            );
        }

        if (requestParameters['setQuickcheckSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'setQuickcheckSettingsRequest',
                'Required parameter "setQuickcheckSettingsRequest" was null or undefined when calling setQuickcheckSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceprovider/{serviceproviderUUID}/quickcheck/settings`;
        urlPath = urlPath.replace(`{${"serviceproviderUUID"}}`, encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetQuickcheckSettingsRequestToJSON(requestParameters['setQuickcheckSettingsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetDatabaseChange200ResponseFromJSON(jsonValue));
    }

    /**
     * Set quickcheck settings
     */
    async setQuickcheckSettings(serviceproviderUUID: string, setQuickcheckSettingsRequest: SetQuickcheckSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetDatabaseChange200Response> {
        const response = await this.setQuickcheckSettingsRaw({ serviceproviderUUID: serviceproviderUUID, setQuickcheckSettingsRequest: setQuickcheckSettingsRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Update serviceprovider details
     */
    async updateServiceproviderRaw(requestParameters: UpdateServiceproviderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetDatabaseChange200Response>> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling updateServiceprovider().'
            );
        }

        if (requestParameters['updateServiceproviderRequest'] == null) {
            throw new runtime.RequiredError(
                'updateServiceproviderRequest',
                'Required parameter "updateServiceproviderRequest" was null or undefined when calling updateServiceprovider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceprovider/{serviceproviderUUID}/whitelabel`;
        urlPath = urlPath.replace(`{${"serviceproviderUUID"}}`, encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateServiceproviderRequestToJSON(requestParameters['updateServiceproviderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetDatabaseChange200ResponseFromJSON(jsonValue));
    }

    /**
     * Update serviceprovider details
     */
    async updateServiceprovider(serviceproviderUUID: string, updateServiceproviderRequest: UpdateServiceproviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetDatabaseChange200Response> {
        const response = await this.updateServiceproviderRaw({ serviceproviderUUID: serviceproviderUUID, updateServiceproviderRequest: updateServiceproviderRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Upload whitelabel logo
     */
    async uploadLogoRaw(requestParameters: UploadLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling uploadLogo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceprovider/{serviceproviderUUID}/whitelabel/logo`;
        urlPath = urlPath.replace(`{${"serviceproviderUUID"}}`, encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Upload whitelabel logo
     */
    async uploadLogo(serviceproviderUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadLogoRaw({ serviceproviderUUID: serviceproviderUUID }, initOverrides);
    }

}
